import React, { useEffect,useState } from 'react';
import axios from "axios";
import {useNavigate,useLocation} from "react-router-dom";
import TravellerCard from './TravellerCard/TravellerCard';
import prevIcon from "../../assets/icons/coloredPrev.svg";
import "./WebCheckIn.css";
import useAuth from "../../customHooks/useAuth"
import { toast } from 'react-toastify';
import { baseUrl } from '../../common/baseUrl';
import PageLoader from '../components/PageLoader/PageLoader';
import axiosInstance from '../../axiosInstance/axiosInstance';


export default function WebCheckIn() {


  const navigate = useNavigate();
  const location = useLocation();
 

  const bookingId = location.state?.bookingId || "";
  const userId = localStorage.getItem("user_id");
  const hotelId = location.state?.hotelId || ""; 

  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";
  const hotelName = location.state?.hotelName || "";
  const hotelAddress = location.state?.hotelAddress || "";

  const guests = location.state?.guests || [];
  const bookedRooms1 = location.state?.bookedRooms || [];
  const tags = location.state?.selectedTags || {};

  const timeArrival = location.state?.timeArrival || "";




  // Stores Users Data
  const [bookedRooms,setBookedRooms] = useState(bookedRooms1) 
  const [totalGuests,setTotalGuests] = useState(0);

  const [isLoading,setIsLoading] = useState(false);

  const [eta, setEta] = useState(timeArrival || ""); // State for expected arrival time

  const handleChangeEta = (e) => {
    setEta(e.target.value);
  };

 
  // Refresh Handle
  useAuth();

  // Check If Booking Id and HotelId are there or not
  useEffect(()=>{
    const checkData = ()=>{
      if(bookingId==="" || hotelId===""){
        navigate("/bookings");
      }
    }
    checkData();
  },[bookingId,hotelId,navigate]);


  // Move Back  
  const MoveBack =()=>{
    navigate(`/bookings/${bookingId}`);
  }

 
  // For Total Guest
  useEffect(() => {
    const countTotalGuests = () => {
 
      // Check if guests is defined and is an array
      if (Array.isArray(guests)) {
        const total = guests.reduce((acc, subArray) => {
          // Ensure each subArray is also an array before getting its length
          return acc + (Array.isArray(subArray) ? subArray.length : 0);
        }, 0);
        setTotalGuests(total);
      } else {
        // If guests is not defined or not an array, set total guests to 0
        setTotalGuests(0);
      }
    };

    countTotalGuests();
  }, [guests]);

 

  const handleNext = () => {
    try {
      console.log("guests :",guests);

      const formattedGuests = guests.map((group) => {
        if (!group.length) return [];

        return group.map((guest) => {
          // Minor (under-18): only a name is carried forward.
          if (guest.is_minor) {
            return {
              name: guest.name,
              is_minor: true,
              contact: null,
              email: "",
              address: "",
              verification_id: "",
            };
          }

          // Existing user
          if (guest.user) {
            return {
               name: guest.name?.trim() || guest.user?.name,
                is_minor: false,
                contact: guest.contact || guest.user?.contact,
                email: guest.email?.trim() || guest.user?.email,
                address: guest.address?.trim() || guest.user?.address,
                verification_id: guest.verification_id || guest.user?.verification_id,
            };
          }

          // Manual guest
          return {
            name: guest.name,
            is_minor: false,
            contact: guest.contact,
            email: guest.email,
            address: guest.address,
            verification_id: guest.verification_id,
          };
        });
      });

      // Validation — minors only need a name; adults need full identity details.
      const isValid = formattedGuests.every((group) => {
        if (!group.length) return true; // Skip empty groups

        return group.every((guest) => {
          if (guest.is_minor) {
            return !!guest.name?.trim();
          }

          const verificationIds = guest.verification_id
            ?.split(",")
            .map((id) => id.trim())
            .filter(Boolean);

          return (
            guest.name?.trim() &&
            guest.contact &&
            guest.email?.trim() &&
            guest.address?.trim() &&
            verificationIds.length === 2
          );
        });
      });

      if (!isValid) {
        toast.error("Details are missing");
        return;
      }

      // Each occupied room must have at least one adult (18+).
      const everyRoomHasAdult = formattedGuests.every((group) => {
        if (!group.length) return true; // Skip empty rooms
        return group.some((guest) => !guest.is_minor);
      });

      if (!everyRoomHasAdult) {
        toast.error("Each room must have at least one adult (18+).");
        return;
      }

      if (formattedGuests.every(group => group.length === 0)) {
        toast.error("Please enter at least one guest to proceed.");
        return;
      }
      navigate("/webCheckinTags", {
        state: {
          hotelId,
          bookingId,
          checkInDate,
          checkOutDate,
          status,
          activeTab,
          hotelName,
          hotelAddress,
          guests : formattedGuests,
          bookedRooms1,
          tags,
          timeArrival: eta, // Pass the expected arrival time to the next page
        },
      });
 
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {
        isLoading && <PageLoader/>
      }
      <div className="web-checkIn">

        {/* Header */}
        <div className="web-checkIn-header">
          <div className="web-checkIn-content">
            <div className="prevIcon">
              <img src={prevIcon} alt="" onClick={MoveBack} />
            </div>
            <div className='webCheckIn-data'>
              <h6>Traveller Details</h6>
              <p>
                Step 1 of 2 · Required
              </p>
            </div> 
          </div>
        </div>

        {/* Traveller Card */}
        <div className='traveller-details'>
          <div className='traveller-header'>
            <h4>
              Who all will be visiting?
            </h4>
          </div>
            {bookedRooms.map((room,index)=>(
              <div key={index} >
                <TravellerCard
                  bookedRoomId = {room.id}
                  userId = {userId}
                  rno = {index}
                  bookedRooms =  {bookedRooms}
                  count = {index+1}
                  guests = {guests}
      
                  // web Check In status
                  webCheckIn_status = {room.webCheckIn_status}

                  // Hotel View
                  checkInDate = {checkInDate}
                  hotelId = {hotelId}
                  bookingId = {bookingId}
                  checkOutDate = {checkOutDate}
                  status = {status}
                  hotelName = {hotelName}
                  hotelAddress = {hotelAddress}
                  activeTab = {activeTab}

                  room = {room}
                  tags = {tags}
                  timeArrival = {eta}
                />
              </div>
            ))}
        </div>

        {/* Expected time arrival */}
        <div className="eta-wrapper">
          <div className="eta">
            <label className="eta-label">Expected arrival time</label>

            <div className="eta-row">
              <div className="eta-field eta-time">
                <span className="eta-icon">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="8.5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path
                      d="M12 7.5V12L15 14"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>

                <input
                  type="datetime-local"
                  name="arrivalDateTime"
                  value={eta}
                  onChange={handleChangeEta}
                  className="eta-input"
                />
              </div>
            </div>
          </div>
        </div>

 
        
        {/* Guest Tip */}
        <div className="guest-tip-wrapper">
          <div className="guest-tip">
            <span className="guest-tip-icon">💡</span>

            <div className="guest-tip-text">
              Tap "Add Guest" to upload each adult's ID. Children under 18 only need a name, and every room needs at least one adult.
            </div>
          </div>
        </div>

        {/* Next Button */}
        <div className='checkin-footer'>
          <button className='checkin-next-btn' onClick={()=>handleNext()}>
            Next
          </button>
        </div>


      </div>
    </>
  )
}
